import {get} from "lodash"
import BaseService from "./Base"

type KonductorGetAllConversation = {
    filter: {
        chatBotId: string
        search?: string
    }
    pagination?: {
        page: number
        pageSize: number
    }
}
class KonductorService extends BaseService {
    async getAllConversations(data: KonductorGetAllConversation): Promise<any> {
        const response = await this.post("/v1/konductors/get-conversations", data)
        return get(response, "data.data", [])
    }
}

export default KonductorService
